module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BreadcrumbsLayout', {
    attrs: {
      "breadcrumbs": _vm.breadcrumbs
    }
  }, [_c('Layout', [_c('AppHeading', {
    attrs: {
      "level": "2",
      "mod": "uppercase, bold"
    }
  }, [_vm._v("Заказать новую программу")]), _c('LoadingSpinner', {
    attrs: {
      "showContent": _vm.isReady && !_vm.isLoading,
      "size": 100
    }
  }, [(_vm.success) ? _c('Message', {
    on: {
      "closeMessage": _vm.closeMessage
    }
  }) : [(_vm.isModulesListNotEmpty) ? _c('ModuleLayout', [_c('CardList', {
    attrs: {
      "list": _vm.items,
      "readonly": _vm.isReadOnly
    },
    on: {
      "removeEmitId": _vm.remove
    }
  }), _c('Textarea', {
    attrs: {
      "label": "Комментарий",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: (_vm.moduleForm.competence_new),
      callback: function($$v) {
        _vm.$set(_vm.moduleForm, "competence_new", $$v)
      },
      expression: "moduleForm.competence_new"
    }
  }), (!_vm.isReadOnly) ? _c('AppText', {
    attrs: {
      "slot": "bottom",
      "mod": "small"
    },
    slot: "bottom"
  }, [_vm._v(_vm._s(_vm.infoText))]) : _vm._e(), (!_vm.isReadOnly) ? _c('Button', {
    attrs: {
      "slot": "bottom",
      "bordered": true,
      "red": _vm.isOpenParamsForm
    },
    on: {
      "click": _vm.toggleParamForm
    },
    slot: "bottom"
  }, [_vm._v(_vm._s(_vm.paramButtonText))]) : _vm._e()], 1) : _vm._e(), (_vm.isOpenParamsForm) ? _c('Form', [_c('FormInput', {
    staticClass: "wide",
    attrs: {
      "label": "Название программы",
      "placeholder": "Название программы",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: (_vm.programForm.program_name),
      callback: function($$v) {
        _vm.$set(_vm.programForm, "program_name", $$v)
      },
      expression: "programForm.program_name"
    }
  }), _c('Select', {
    attrs: {
      "label": "Профессионалная область",
      "placeholder": "Профессионалная область",
      "readonly": _vm.isReadOnly,
      "required": true,
      "error": _vm.errors.prof_sphere_id,
      "errorText": _vm.errors.prof_sphere_id,
      "options": _vm.profSpheres
    },
    model: {
      value: (_vm.requiredForm.prof_sphere_id),
      callback: function($$v) {
        _vm.$set(_vm.requiredForm, "prof_sphere_id", $$v)
      },
      expression: "requiredForm.prof_sphere_id"
    }
  }), _c('Select', {
    attrs: {
      "label": "Компетенция",
      "placeholder": "Компетенция",
      "readonly": _vm.isReadOnly,
      "options": _vm.competences
    },
    model: {
      value: (_vm.programForm.competence_id),
      callback: function($$v) {
        _vm.$set(_vm.programForm, "competence_id", $$v)
      },
      expression: "programForm.competence_id"
    }
  }), _c('Select', {
    attrs: {
      "label": "Профессия",
      "placeholder": "Профессия",
      "readonly": _vm.isReadOnly,
      "options": _vm.professions
    },
    model: {
      value: (_vm.programForm.profession_id),
      callback: function($$v) {
        _vm.$set(_vm.programForm, "profession_id", $$v)
      },
      expression: "programForm.profession_id"
    }
  }), _c('Select', {
    attrs: {
      "label": "Форма обучения",
      "placeholder": "Форма обучения",
      "readonly": _vm.isReadOnly,
      "required": true,
      "error": _vm.errors.edu_forms,
      "errorText": _vm.errors.edu_forms,
      "multiple": true,
      "scroll": true,
      "options": _vm.educationForm
    },
    model: {
      value: (_vm.requiredForm.edu_forms),
      callback: function($$v) {
        _vm.$set(_vm.requiredForm, "edu_forms", $$v)
      },
      expression: "requiredForm.edu_forms"
    }
  }), _c('Select', {
    attrs: {
      "label": "Категория обучающихся",
      "placeholder": "Категория обучающихся",
      "readonly": _vm.isReadOnly,
      "required": true,
      "error": _vm.errors.edu_cats,
      "errorText": _vm.errors.edu_cats,
      "multiple": true,
      "scroll": true,
      "options": _vm.educationCategories
    },
    model: {
      value: (_vm.requiredForm.edu_cats),
      callback: function($$v) {
        _vm.$set(_vm.requiredForm, "edu_cats", $$v)
      },
      expression: "requiredForm.edu_cats"
    }
  }), _c('Select', {
    attrs: {
      "label": "Продолжительность обучения",
      "placeholder": "Продолжительность обучения",
      "readonly": _vm.isReadOnly,
      "required": true,
      "error": _vm.errors.edu_durations,
      "errorText": _vm.errors.edu_durations,
      "multiple": true,
      "scroll": true,
      "options": _vm.eduDurations
    },
    model: {
      value: (_vm.requiredForm.edu_durations),
      callback: function($$v) {
        _vm.$set(_vm.requiredForm, "edu_durations", $$v)
      },
      expression: "requiredForm.edu_durations"
    }
  }), _c('FormInput', {
    attrs: {
      "label": "Количество обучающихся",
      "placeholder": "Количество обучающихся",
      "readonly": _vm.isReadOnly,
      "error": _vm.studentsCountError,
      "errorText": _vm.errorsText
    },
    model: {
      value: (_vm.programForm.students_count),
      callback: function($$v) {
        _vm.$set(_vm.programForm, "students_count", $$v)
      },
      expression: "programForm.students_count"
    }
  }), _c('FormInput', {
    attrs: {
      "label": "Максимальная стоимость",
      "placeholder": "Максимальная стоимость руб.",
      "readonly": _vm.isReadOnly,
      "error": _vm.costMaxError,
      "errorText": _vm.errorsText
    },
    model: {
      value: (_vm.programForm.cost_max),
      callback: function($$v) {
        _vm.$set(_vm.programForm, "cost_max", $$v)
      },
      expression: "programForm.cost_max"
    }
  }), _c('Textarea', {
    staticClass: "wide",
    attrs: {
      "readonly": _vm.isReadOnly,
      "label": _vm.descText
    },
    model: {
      value: (_vm.programForm.user_comment),
      callback: function($$v) {
        _vm.$set(_vm.programForm, "user_comment", $$v)
      },
      expression: "programForm.user_comment"
    }
  })], 1) : _vm._e(), (!_vm.isReadOnly) ? _c('Footer', [(!_vm.isReadOnly) ? _c('Button', {
    attrs: {
      "big": true,
      "bordered": true
    },
    on: {
      "click": _vm.cancellation
    }
  }, [_vm._v("Отменить")]) : _vm._e(), (!_vm.isReadOnly) ? _c('Button', {
    attrs: {
      "big": true,
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.sendNewProgram
    }
  }, [_vm._v("Отправить заявку")]) : _vm._e()], 1) : _vm._e()]], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-109c01ad","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/newprogram/NewProgram.vue
// module id = c769391a2748dcb2670f
// module chunks = 10